import React, { useEffect, useState } from "react";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import ReactDOM from "react-dom";
import attachfile from "../../utils/attachfile.png";  
import { format } from "date-fns";
import whatsapp from "../../utils/whatsapp.png";
import ScheduleActivityPopup from "../../modals/ScheduleActivityModal";
import HistoryDisplay from "./HistoryDisplay";
import { Box, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import ActivityLog from "./ActivityLog";
import EscalateLead from "../../modals/EscalateLead";
import ProductsDetails from "./ProductsDetails";
// import QuoteLead from "../modals/QuoteLead";
import axios from "axios";
import QuotationComponent from "../../modals/QuoteLead";
import { useNavigate } from "react-router-dom";

const Drawer = ({
  showDrawer,
  setShowDrawer,
  selectedLead,
  handleInputChange,
  handleSave,
  stageMapping,
  leadsWithHistory,
  rows,
  setRows,
  setShowBreadcrumbs,
  // handleQuoteButtonClick,
  // quoteModal,
  // setQuoteModal,
  // productDetails
}) => {

  let company_code_from_local_storage = localStorage.getItem("companyCode") ? localStorage.getItem("companyCode") : "-"
  let apiPaths_from_local_storage = localStorage.getItem("apiPaths") ? JSON.parse( localStorage.getItem("apiPaths") ) : "-"
  
  const [coordinatorList, setCoordinatorList] = useState(null);
  const [salespersonList, setSalesPersonList] = useState(null);

  const currentDepartmentFromLocalStorage = localStorage.getItem(
    "currentSelectedDepartment"
  );

  const navigate = useNavigate();

  const onQuotesAndInvoice = () => {
    navigate("/quoteLead", { state: { selectedLead } }); // ✅ Navigate with data
  };

  //   const [navigateToQuotation,setNavigateToQuotation]=useState(false)

  //  const onQuotesAndInvoice=()=>{
  //     setNavigateToQuotation(true)
  //   }

  console.log("rows from drawer", rows);
  console.log("selectedLead from drawer", selectedLead);

  // const [qualifiedLeadToQuote,setQualifiedLeadToQuote]=useState(null)
  // setQualifiedLeadToQuote(selectedLead)
  // console.log("qualifiedLeadToQuote::::::",qualifiedLeadToQuote)

  const productDetails = [
    {
      leadItemCode: selectedLead?.leadItemCode,
      leadItemAmount: selectedLead?.leadItemAmount,
      leadItemCurrentStock: selectedLead?.leadItemCurrentStock,
      leadItemDescription: selectedLead?.leadItemDescription,
      leadItemPrice: selectedLead?.leadItemPrice,
      leadItemQuantity: selectedLead?.leadItemQuantity,
      leadItemUnit: selectedLead?.leadItemUnit,
    },
  ];
  // console.log("productDetails in drawer:", productDetails);
  // console.log("rows in drawer:", rows);

  const leadSourceMapping = {
    walkin: "Walk-in",
    phone: "Phone",
    whatsapp: "Whatsapp",
    email: "E-mail",
    online: "Online",
    others: "Others",
  };

  const territoryMapping = {
    dubai: "Dubai",
    abudhabi: "Abu Dhabi",
    sharjah: "Sharjah",
    ajman: "Ajman",
    othersTerritory: "Others",
  };

  const countryMapping = {
    unitedArabEmirates: "United Arab Emirates",
    unitedStates: "United States",
    unitedKingdom: "United Kingdom",
    india: "India",
    canada: "Canada",
    australia: "Australia",
    otherCountry: "Others",
  };

  const [selectedLeadIdAttachment, setSelectedLeadIdAttachment] =
    useState(null);
  const [activitiesModal, setActivitiesModal] = useState(false);
  const [escalateModal, setEscalateModal] = useState(false);
  const [quoteModal, setQuoteModal] = useState(false);
  const [quoteModal2, setQuoteModal2] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const handleClose = () => setActivitiesModal(false);
  const handleCloseEscalate = () => setEscalateModal(false);
  const handlePriorityClick = (level) => {
    // setFormData({ ...selectedLead, priority: level });
  };

  const [showProducts, setShowProducts] = useState(false);

  const [currentLead, setCurrentLead] = useState(null);
  const [currentLeadEscalate, setCurrentLeadEscalate] = useState(null);
  const [currentLeadQuote, setCurrentLeadQuote] = useState(null);
  const [leads, setLeads] = useState(null);

  // console.log('currentLead::',currentLead)
  const onActivities = (leadId) => {
    const selectedLeadScheduleActivity = leadId;
    setCurrentLead(selectedLeadScheduleActivity);
    setActivitiesModal(true);
  };

  const onEscalateLead = (leadId) => {
    const selectedLeadEscalateLead = leadId;
    setCurrentLeadEscalate(selectedLeadEscalateLead);
    setEscalateModal(true);
  };

  const onQuoteLead = (leadId) => {
    const selectedLeadQuoteLead = leadId;
    setCurrentLeadQuote(selectedLeadQuoteLead);
    setQuoteModal(true);
    setShowBreadcrumbs(true);
  };

  const updateLeadActivityTimeline = (currentLead, activityEntry) => {
    const updatedLeads = rows.map((row) => {
      // Match the lead by its ID
      if (row.id === currentLead) {
        return {
          ...row,
          leadTimeline: [...(row.leadTimeline || []), activityEntry], // Update leadTimeline
        };
      }
      return row; // Keep other leads unchanged
    });

    setRows(updatedLeads); // Update state with new leads array
    localStorage.setItem("leads", JSON.stringify(updatedLeads)); // Save updated leads to localStorage
    // console.log("Updated Leads 143:", updatedLeads);
  };

  const theme = createTheme({
    typography: {
      fontFamily: `'Figtree', sans-serif`,
    },
  });

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [value, setValue] = useState("1");

  const [fileName, setFileName] = useState("No file chosen");

  const addFileToLeadTimeline = (currentLead, file) => {
    const updatedLeads = rows.map((row) => {
      // Match the lead by its ID
      if (row.id === currentLead) {
        // console.log('row.id:',row.id)
        // console.log('currentLead:',currentLead)
        return {
          ...row,
          leadTimeline: [
            ...(row.leadTimeline || []),
            {
              type: "file", // Specify the type as 'file'
              fileName: file.name,
              fileSize: file.size,
              fileType: file.type,
              date: new Date().toISOString(), // Add a timestamp
            },
          ],
        };
      }
      return row; // Keep other leads unchanged
    });

    // console.log("Updated Leads with File:", updatedLeads);
    setRows(updatedLeads); // Update state with new leads array
    localStorage.setItem("leads", JSON.stringify(updatedLeads)); // Save updated leads to localStorage
    // console.log("Updated Leads with File:", updatedLeads);
  };

  const handleFileAttachment = (event, lead) => {
    const file = event.target.files[0]; // Get the selected file
    if (file) {
      // Set file name for display
      setFileName(file.name);

      // Update the selectedLead.docs property (or append to the array if it's an array)
      lead.docs = lead.docs ? [...lead.docs, file] : [file];

      console.log("Updated selectedLead:", lead);
    }
  };

  const [onProductTable, setOnProductTable] = useState(false);
  const handleProductTable = () => {
    setOnProductTable(true);
  };

  const productEntryInAllEntries = (productEntryInAllEntries) => {
    // itemCode:selectedLead.itemCode
    // itemCode:selectedLead.itemCode
    // itemCode:selectedLead.itemCode
    // itemCode:selectedLead.itemCode
    console.log("productEntryInAllEntries:::", productEntryInAllEntries);
  };

  const saveProductDetails = (updatedProducts) => {
    console.log("Updated Products:", updatedProducts);
    // Perform API call or update state in parent
  };

  const handleOpenModal = (leadId) => {
    console.log("handleOpenModal leadId", leadId);
    setIsModalOpen(true);
    setSelectedLeadIdAttachment(leadId);
    // set the lead_id from api , not local
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedImage(null);
    setPreviewImage(null);
  };

  const handleAttachFileChange = (event) => {
    const file = event.target.files[0];
    console.log("file", file);
    if (file) {
      setSelectedImage(file);
      setPreviewImage(URL.createObjectURL(file)); // Preview image before upload
    }
  };

  const handleAttachFileSave = async () => {
    if (!selectedImage) {
      alert("Please select a File!");
      return;
    }
    console.log("File attached lead id", setSelectedLeadIdAttachment);

    const formData = new FormData();
    formData.append("UserId", selectedLeadIdAttachment);
    formData.append("Description", "LEADIMAGE");
    formData.append("Image", selectedImage);
    formData.append("ImagePath", "C:\\bondtime_web_app\\BONDTIME_LEAD_IMG");

    console.log("Sending FormData...");
    for (let pair of formData.entries()) {
      console.log(pair[0] + ": ", pair[1]); // Debugging
    }

    try {
      const config = {
        headers: { "Content-Type": "multipart/form-data" },
      };
      const response = await axios.post(
        `https://${company_code_from_local_storage}.dyndns-server.com:91/Posts`,
        formData,
        config
      );

      console.log("Upload Success:", response.data);
    } catch (error) {
      console.error(
        "Upload Error:",
        error.response ? error.response.data : error.message
      );
    }
  };

  const callCordinatorListAPI = () => {
    const apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/MasterCount/${company_code_from_local_storage}/COORDINATORLIST/-/${currentDepartmentFromLocalStorage}`;
    axios
      .get(apiUrl)
      .then((res) => {
        setCoordinatorList([
          { EMP_ID: "GENERAL", NAME: "GENERAL" },
          ...res.data,
        ]);
      })
      .catch((err) => {});
  };

  const callSalesPersonListAPI = () => {
    const apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/MasterCount/${company_code_from_local_storage}/SALESPERSONLIST/-/${currentDepartmentFromLocalStorage}`;
    axios
      .get(apiUrl)
      .then((res) => {
        setSalesPersonList(res.data);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    callCordinatorListAPI();
    callSalesPersonListAPI();
  }, []);

  const updateLeadStatus = (dataForAPI) => {

    let company_code_from_local_storage = localStorage.getItem("companyCode") ? localStorage.getItem("companyCode") : "-"
  let apiPaths_from_local_storage = localStorage.getItem("apiPaths") ? JSON.parse( localStorage.getItem("apiPaths") ) : "-"

    let arrayWeHaveToGiveToAPI = [
      {
        CmpCode: company_code_from_local_storage,
        mode: "EDIT",
        lead_id: dataForAPI.lead_id,
        lead_entryTime: dataForAPI.lead_entryTime,
        lead_creatorid: dataForAPI.lead_creatorid,
        lead_coordinator: dataForAPI.lead_coordinator,
        lead_salesperson: dataForAPI.lead_salesperson,
        lead_teamid: dataForAPI.lead_teamid,
        lead_CampaignId: dataForAPI.lead_CampaignId,
        lead_account: dataForAPI.lead_account,
        lead_organization: dataForAPI.lead_organization,
        lead_notes: dataForAPI.lead_notes,
        lead_country: dataForAPI.lead_country,
        lead_city: dataForAPI.lead_city,
        lead_territory: dataForAPI.lead_territory,
        lead_area: dataForAPI.lead_area,
        lead_streetaddress: dataForAPI.lead_streetaddress,
        lead_location: dataForAPI.lead_location,
        lead_appartment: dataForAPI.lead_appartment,
        lead_primarycontact: dataForAPI.lead_primarycontact,
        lead_primarycontacttitle: dataForAPI.lead_primarycontacttitle,
        lead_phone: dataForAPI.lead_phone,
        lead_isphonewhatsapp: dataForAPI.lead_isphonewhatsapp,
        lead_alt_phone: dataForAPI.lead_alt_phone,
        lead_alt_isphonewhatsapp: dataForAPI.lead_alt_isphonewhatsapp,
        lead_email: dataForAPI.lead_email,
        lead_stage: "",
        lead_probability: Number(dataForAPI.lead_probability),
        lead_priority: dataForAPI.lead_priority,
        lead_priority: dataForAPI.lead_priority,
        lead_source: dataForAPI.lead_source,
        lead_status: dataForAPI.lead_status,
        lead_assignedto: dataForAPI.lead_assignedto,
        lead_bookedamount: Number(dataForAPI.lead_bookedamount),
        lead_currencycode: dataForAPI.lead_currencycode,
        lead_currencyrate: "1",
        deptno: "",
        prod_code: "",
        prod_Description: "",
        prod_Unit: "",
        prod_Qty: 0,
        prod_Price: 0,
        prod_Amount: 0,
        prod_Comments: "",
        prod_imagepath: "",
      },
    ];
    const jsonToSend = JSON.stringify(arrayWeHaveToGiveToAPI);
    console.log("arrayWeHaveToGiveToAPI:", arrayWeHaveToGiveToAPI);
    console.log("jsonToSend:", jsonToSend);

    const apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMStatusUpdate/${company_code_from_local_storage}/LEADSTATUS/${dataForAPI.lead_id}/${dataForAPI.lead_status}`;

    axios
      .get(apiUrl, jsonToSend, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        console.log("res is ", dataForAPI);
        console.log("success lead status change");

       
        window.location.reload();
      
      })
      .catch((err) => {
        console.log("error while posting lead", err.response.data);
      });
  };

  const clickedOnResetAsNewLead = ()=>{
    updateLeadStatus({ ...selectedLead, lead_status: "newLead" })
  }

  return (
    <div>
      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 max-h-[100%]">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96">
            <h2 className="text-lg font-semibold mb-4">Attach File</h2>

            {/* File Input */}
            <input
              type="file"
              accept="image/*"
              onChange={handleAttachFileChange}
            />

            {/* Image Preview */}
            {previewImage && (
              <div className="mt-4">
                <img
                  src={previewImage}
                  alt="Preview"
                  className="w-32 h-32 object-cover border rounded-md"
                />
              </div>
            )}

            <div className="flex justify-end mt-4">
              <button
                onClick={handleCloseModal}
                className="px-4 py-2 bg-gray-500 text-white rounded-md mr-2"
              >
                Cancel
              </button>
              <button
                onClick={handleAttachFileSave}
                className="px-4 py-2 bg-blue-500 text-white rounded-md"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
      <div
        style={{ backgroundColor: "#f8f8f8 " }}
        className={`fixed right-0 top-0 max-h-[100vh] w-1/2  shadow-2xl z-40 p-3 overflow-y-auto transition-all duration-300 ease-in-out max-h-[100vh] overflow-y-auto scrollbar-thin ${
          showDrawer ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <button
          className="absolute top-4 right-4 text-gray-500 hover:text-black"
          onClick={() => setShowDrawer(false)}
        >
          ✖
        </button>
        {selectedLead ? (
          <>
            {/* Profile Section */}
            <div className="flex flex-col items-center space-y-2 border-b pb-3 mb-4">
              {/* Profile Image */}
              {/* <img
    src={selectedLead.avatar || "https://via.placeholder.com/60"}
    alt={selectedLead.name}
    className="w-16 h-16 rounded-full object-cover"
  /> */}

              {/* Profile Details */}
              <div className="text-center">
                <h3 className="text-xl font-semibold">
                  {selectedLead.lead_primarycontact || "Lead Name"}
                </h3>
                <p className="text-gray-500">
                  Lead Created on:{" "}
                  {selectedLead?.lead_entryTime &&
                  !isNaN(new Date(selectedLead.lead_entryTime).getTime())
                    ? format(
                        new Date(selectedLead.lead_entryTime),
                        "MMMM do, yyyy 'at' h:mm a"
                      )
                    : "N/A"}
                </p>
              </div>

              {/* Contact Details */}
              <div className="text-center text-gray-500 space-y-1 mb-4">
                {/* Lead Created on: {selectedLead.leadEntryTime } */}

                <p className="text-gray-500 ">
                  Phone: {selectedLead.lead_phone || ""}
                </p>
                <p className="text-gray-500 ">
                  Email: {selectedLead.lead_email || ""}
                </p>
                <p className="text-gray-500  flex items-center justify-center gap-2">
                  {/* Stage: {selectedLead.stage || "d.collins@boyle.info"} */}
                  <p>{/* Stage: */}</p>

                  <button
                    className={`text-white text-center p-1 my-0.5 rounded ${
                      selectedLead.lead_stage === "new"
                        ? "bg-yellow-500"
                        : selectedLead.lead_stage === "discovery"
                        ? "bg-teal-500"
                        : selectedLead.lead_stage === "proposal"
                        ? "bg-sky-500"
                        : selectedLead.lead_stage === "negotiation"
                        ? "bg-orange-600"
                        : selectedLead.lead_stage === "won"
                        ? "bg-green-600"
                        : selectedLead.lead_stage === "lost"
                        ? "bg-red-600"
                        : "bg-gray-300"
                    }`}
                  >
                    {selectedLead.lead_stage
                      ? selectedLead.lead_stage.charAt(0).toUpperCase() +
                        selectedLead.lead_stage.slice(1)
                      : "No Stage Assigned"}
                  </button>

{
  selectedLead.lead_stage === "new" &&  <button className="rounded-lg bg-black p-2 hover:bg-blue-800 text-white" onClick={()=>clickedOnResetAsNewLead(selectedLead)}>Reset as New Lead</button>
}
                 
                </p>
                <p className="text-gray-500 ">
                  Organization:{" "}
                  {selectedLead.lead_organization || "Organization not added!"}
                </p>
                {selectedLead.Cnt > 0 && (
                  <div className="  p-2 m-4 flex justify-center items-center ">
                    <button
                      type="button"
                      className="bg-yellow-400 px-2 py-2 rounded-lg text-white"
                      onClick={() => setShowProducts(true)}
                    >
                      View Product Details
                    </button>
                    {showProducts &&
                      ReactDOM.createPortal(
                        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                          <div className="bg-white rounded-lg shadow-lg p-6 max-w-3xl w-full mx-4">
                            <ProductsDetails
                              // lead={selectedLead.name}
                              lead={selectedLead.lead_primarycontact}
                              productDetails={productDetails}
                              productEntryInAllEntries={
                                productEntryInAllEntries
                              }
                              setShowProducts={setShowProducts}
                              onSaveProducts={saveProductDetails} // Pass save handler
                            />
                          </div>
                        </div>,
                        document.body // Render the overlay directly to the body
                      )}
                  </div>
                )}
              </div>
            </div>

            {/* Action Icons */}
            <div className="flex justify-center items-center space-x-6 mb-4">
              <button
                onClick={() => onActivities(selectedLead.id)}
                className=" flex items-center justify-center rounded-lg bg-blue-100 p-2 hover:bg-blue-200 text-blue-500"
                aria-label="Address"
              >
                Schedule Activity
                {/* <span> Schedule Activity</span> */}
              </button>

              <button
                onClick={() => onEscalateLead(selectedLead.id)}
                className=" flex items-center justify-center rounded-lg bg-blue-100 p-2 hover:bg-blue-200 text-blue-500"
                aria-label="Address"
              >
                Escalate Lead
              </button>

              <button
                // onClick={() => onQuoteLead(selectedLead.id)}
                // onClick={() => openQuoteModal(selectedLead.id)}
                // onClick={() => handleQuoteButtonClick(selectedLead.lead_id)}
                onClick={onQuotesAndInvoice}
                className=" flex items-center justify-center rounded-lg bg-blue-100 p-2 hover:bg-blue-200 text-blue-500"
                aria-label="Address"
              >{
                (selectedLead.lead_teamid === "0" || selectedLead.lead_teamid === "") ? "Create Quotation" : "Modify Quotation"

              }
                
              </button>

              {activitiesModal &&
                selectedLead &&
                ReactDOM.createPortal(
                  <div className="fixed inset-0 z-50 flex items-center justify-center ">
                    <div className="relative z-100">
                      <ScheduleActivityPopup
                        lead={selectedLead}
                        updateLeadActivityTimeline={updateLeadActivityTimeline}
                        handleClose={handleClose}
                      />
                    </div>
                  </div>,
                  document.body
                )}

              {escalateModal &&
                selectedLead &&
                ReactDOM.createPortal(
                  <div className="fixed inset-0 z-50 flex items-center justify-center ">
                    <div className="relative z-100">
                      <EscalateLead
                        lead={selectedLead}
                        updateLeadActivityTimeline={updateLeadActivityTimeline}
                        handleClose={handleCloseEscalate}
                      />
                    </div>
                  </div>,
                  document.body
                )}
            </div>

            {/* {navigateToQuotation && selectedLead && ( // ✅ Ensure selectedLead exists before rendering
      <QuotationComponent selectedLead={selectedLead} />
    )} */}

            {/* {quoteModal && */}
            {/* {quoteModal2 &&
            selectedLead &&
            ReactDOM.createPortal(
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"> */}
            {/* <div> */}
            {/* <div
                  className=" rounded-lg  p-3  w-full mx-4"
                  style={{ background: "#f8f8f8" }}
                > */}
            {/* <QuotationComponent
                  selectedLead={selectedLead}
                    // isOpen={quoteModal}
                    // onClose={() => setQuoteModal(false)}
                    // productDetails={productDetails}
                    // qualifiedLeadToQuote={qualifiedLeadToQuote}
                  /> */}
            {/* </div>
              </div>,
              document.body
            )} */}

            {/* </div> */}

            {/* Lead Info section  */}
            <div className="flex gap-3 max-h-[80vh] overflow-y-auto scrollbar-thin ">
              {/* Form Section */}
              <div className="formDiv  w-[40%]  bg-white p-4 rounded-md shadow-md max-h-[80vh] overflow-y-auto scrollbar-thin">
                <h3 className="text-xl font-semibold mb-4">Lead Info</h3>
                <form onSubmit={handleSave}>
                  <div className="mb-4">
                    <TextField
                      label="Lead Name"
                      fullWidth
                      variant="standard"
                      value={selectedLead.lead_primarycontact || ""}
                      onChange={(e) => handleInputChange(e, "lead")}
                    />
                  </div>
                  <div className="mb-4">
                    <TextField
                      label="Email"
                      fullWidth
                      variant="standard"
                      value={selectedLead.lead_email || ""}
                      onChange={(e) => handleInputChange(e, "email")}
                    />
                  </div>
                  <div className="flex items-center justify-center">
                    <div className="mb-4">
                      <TextField
                        label="Phone"
                        fullWidth
                        variant="standard"
                        value={selectedLead.lead_phone || ""}
                        onChange={(e) => handleInputChange(e, "phone")}
                      />
                    </div>

                    <div className="mb-4 flex items-center space-x-2">
                      <label className="flex items-center">
                        {/* <input
      type="checkbox"
      checked={selectedLead.isPhoneWhatsApp || false}
      onChange={(e) =>
        handleInputChange(e, "isPhoneWhatsApp", e.target.checked)
      }
      className="w-6 h-6 rounded-full appearance-none bg-gray-200 checked:bg-green-500 focus:outline-none focus:ring-2 focus:ring-green-400 transition cursor-pointer"
    /> */}

                        <img
                          src={whatsapp}
                          alt="whatsapp-icon"
                          className="w-5 h-5 mr-2" // Adjust icon size and spacing
                        />
                        <input
                          type="checkbox"
                          checked={selectedLead.lead_isphonewhatsapp || false}
                          onChange={(e) =>
                            handleInputChange(
                              e,
                              "isPhoneWhatsApp",
                              e.target.checked
                            )
                          }
                          className="rounded border border-sm shadow"
                        />
                      </label>
                    </div>
                  </div>

                  <div className="flex items-center justify-center">
                    <div className="mb-4">
                      <TextField
                        label="Alternate Phone"
                        fullWidth
                        variant="standard"
                        value={selectedLead.lead_alt_phone || ""}
                        onChange={(e) => handleInputChange(e, "alternatePhone")}
                      />
                    </div>

                    {/* <div className="mb-4">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={
                            selectedLead.isAlternatePhoneWhatsApp || false
                          }
                          onChange={(e) =>
                            handleInputChange(
                              e,
                              "isAlternatePhoneWhatsApp",
                              e.target.checked
                            )
                          }
                          sx={{
                            borderRadius: "8px", // rounded border
                            border: "1px solid", // border
                            outline: "none",
                            padding: "0", // optional to adjust padding
                          }}
                          // className="rounded border border-sm" // Apply rounded border class to the checkbox
                        />
                      }
                      label={
                        <span className="text-xs">
                      Alternate <img src={whatsapp} alt="whatsapp-icon" /> ?</span>
                      } // Reduce label font size using text-sm
                    />
                  </div>
                </div> */}

                    <label className="flex items-center">
                      {/* <input
      type="checkbox"
      checked={selectedLead.isAlternatePhoneWhatsApp || false}
      onChange={(e) =>
        handleInputChange(e, "isAlternatePhoneWhatsApp", e.target.checked)
      }
      className="w-6 h-6 rounded-full appearance-none bg-gray-200 checked:bg-green-500 focus:outline-none focus:ring-2 focus:ring-green-400 transition cursor-pointer"
      /> */}

                      <img
                        src={whatsapp}
                        alt="whatsapp-icon"
                        className="w-5 h-5 mr-2" // Adjust icon size and spacing
                      />

                      <input
                        type="checkbox"
                        checked={selectedLead.lead_alt_isphonewhatsapp || false}
                        onChange={(e) =>
                          handleInputChange(
                            e,
                            "isAlternatePhoneWhatsApp",
                            e.target.checked
                          )
                        }
                        className="rounded border border-sm shadow"
                      />
                    </label>
                  </div>

                  <div className="mb-4">
                    <TextField
                      label="Oragnization"
                      fullWidth
                      variant="standard"
                      value={selectedLead.lead_organization || ""}
                      onChange={(e) => handleInputChange(e, "organization")}
                    />
                  </div>

                  <div className="mb-4">
                    <TextField
                      label="Title"
                      fullWidth
                      variant="standard"
                      value={selectedLead.lead_primarycontacttitle || ""}
                      onChange={(e) => handleInputChange(e, "title")}
                    />
                  </div>

                  <div className="mb-4">
                    <FormControl fullWidth variant="standard">
                      <InputLabel id="stage-label">Stage</InputLabel>
                      <Select
                        labelId="stage-label"
                        id="stage"
                        value={selectedLead.lead_stage || ""}
                        onChange={(e) => handleInputChange(e, "stage")}
                      >
                        {Object.entries(stageMapping).map(
                          ([key, value], index) => (
                            <MenuItem key={`${key}-${index}`} value={key}>
                              {value && (
                                <button
                                  className={`w-full text-white text-center p-1 my-0.5 rounded ${
                                    value === "New"
                                      ? "bg-yellow-500"
                                      : value === "Discovery"
                                      ? "bg-teal-500"
                                      : value === "Proposal"
                                      ? "bg-sky-500"
                                      : value === "Negotiation"
                                      ? "bg-orange-600"
                                      : value === "Won"
                                      ? "bg-green-600"
                                      : value === "Lost"
                                      ? "bg-red-600"
                                      : "bg-gray-300"
                                  }`}
                                >
                                  {value}
                                </button>
                              )}
                            </MenuItem>
                          )
                        )}
                      </Select>
                    </FormControl>
                  </div>

                  <div className="mb-4">
                    <FormControl fullWidth variant="standard">
                      <InputLabel id="lead-source">Lead Source</InputLabel>
                      <Select
                        labelId="lead-source"
                        id="leadSource"
                        value={selectedLead?.lead_source || ""}
                        onChange={(e) => handleInputChange(e, "leadSource")}
                      >
                        {Object.entries(leadSourceMapping).map(
                          ([key, value]) => (
                            <MenuItem key={key} value={key}>
                              {/* Add any conditional styling or buttons here if needed */}
                              {value}
                            </MenuItem>
                          )
                        )}
                      </Select>
                    </FormControl>
                  </div>

                  <div className="mb-4">
                    <TextField
                      label="Lead Probability (%)"
                      fullWidth
                      variant="standard"
                      value={selectedLead.lead_probability || ""}
                      onChange={(e) => handleInputChange(e, "probability")}
                    />
                  </div>
                  <div className="mb-0">
                   <p>Co-ordinator</p>
                      {
                        coordinatorList?.filter((item) => {
                          return (
                            item.EMP_ID?.trim() ==
                            selectedLead.lead_coordinator?.trim()
                          );
                        })[0]?.NAME
                      }
                   
                  </div>

                  <div className="mt-2">
                   <p>Salesperson</p>
                      {
                        salespersonList?.filter((item) => {
                          return (
                            item.EMP_ID?.trim() ==
                            selectedLead.lead_salesperson?.trim()
                          );
                        })[0]?.NAME
                      }
                   
                  </div>

                  <div className="mb-4 flex items-center space-x-4 mt-2">
                    {/* Currency Selector */}
                    <TextField
                      select
                      label="Currency"
                      name="currency"
                      value={selectedLead.lead_currencycode || ""}
                      onChange={(e) => handleInputChange(e, "currency")}
                      variant="standard"
                      sx={{
                        width: "100px",
                        "& .MuiInputLabel-root": {
                          fontFamily: "Figtree, sans-serif", // Apply Figtree font for label
                        },
                      }}
                    >
                      <MenuItem value="AED">AED</MenuItem>
                      <MenuItem value="USD">USD</MenuItem>
                      <MenuItem value="EUR">EUR</MenuItem>
                      <MenuItem value="GBP">GBP</MenuItem>
                      <MenuItem value="INR">INR</MenuItem>
                      <MenuItem value="JPY">JPY</MenuItem>
                      <MenuItem value="AUD">AUD</MenuItem>
                    </TextField>

                    {/* Booked Amount */}
                    <TextField
                      label="Booked Amount"
                      name="bookedAmount"
                      type="number"
                      value={selectedLead.lead_bookedamount || ""}
                      onChange={(e) => handleInputChange(e, "bookedAmount")}
                      fullWidth
                      variant="standard"
                      InputProps={{
                        inputProps: { min: 0 }, // Prevent negative amounts
                      }}
                      sx={{
                        "& .MuiInputLabel-root": {
                          fontFamily: "Figtree, sans-serif", // Apply Figtree font for label
                        },
                      }}
                    />
                  </div>

                  <div className="mb-4">
                    <FormControl fullWidth variant="standard">
                      <InputLabel id="territory">Territory</InputLabel>
                      <Select
                        labelId="territory"
                        id="territory"
                        value={selectedLead.lead_territory || ""}
                        onChange={(e) => handleInputChange(e, "territory")}
                      >
                        {Object.entries(territoryMapping).map(
                          ([key, value]) => (
                            <MenuItem key={key} value={key}>
                              {/* Add any conditional styling or buttons here if needed */}
                              {value}
                            </MenuItem>
                          )
                        )}
                      </Select>
                    </FormControl>
                  </div>

                  <div className="mb-4">
                    <FormControl fullWidth variant="standard">
                      <InputLabel id="country">Country</InputLabel>
                      <Select
                        labelId="country"
                        id="country"
                        value={selectedLead.lead_country || ""}
                        onChange={(e) => handleInputChange(e, "country")}
                      >
                        {Object.entries(countryMapping).map(([key, value]) => (
                          <MenuItem key={key} value={key}>
                            {/* Add any conditional styling or buttons here if needed */}
                            {value}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>

                  <div className="mb-4">
                    <TextField
                      label="Street Address"
                      fullWidth
                      variant="standard"
                      value={selectedLead.lead_streetaddress || ""}
                      onChange={(e) => handleInputChange(e, "streetAddress")}
                    />
                  </div>

                  <div className="mb-4">
                    <TextField
                      label="City"
                      fullWidth
                      variant="standard"
                      value={selectedLead.lead_city || ""}
                      onChange={(e) => handleInputChange(e, "city")}
                    />
                  </div>

                  <div className="mb-4">
                    <TextField
                      label="Apartment"
                      fullWidth
                      variant="standard"
                      value={selectedLead.lead_appartment || ""}
                      onChange={(e) => handleInputChange(e, "apartment")}
                    />
                  </div>

                  <div className="mb-4">
                    <TextField
                      label="Location"
                      fullWidth
                      variant="standard"
                      value={selectedLead.lead_location || ""}
                      onChange={(e) => handleInputChange(e, "location")}
                    />
                  </div>

                  <div className="mb-4">
                    <TextField
                      label="Area"
                      fullWidth
                      variant="standard"
                      value={selectedLead.lead_area || ""}
                      onChange={(e) => handleInputChange(e, "area")}
                    />
                  </div>

                  {/* Priority Selection */}
                  <div className="mb-4 flex gap-3 items-center justify-center">
                    <label className="block font-medium text-black text-opacity-60">
                      Priority
                    </label>
                    <div className="flex space-x-2">
                      {[1, 2, 3].map((level, index) => (
                        <span
                          key={`${level}-${index}`}
                          className={`text-2xl transition-all duration-300 ease-in-out ${
                            selectedLead?.lead_priority >= level
                              ? "text-yellow-500 transform scale-110"
                              : "text-gray-400 transform scale-100"
                          }`}
                        >
                          ★
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* Attach File  */}

                  <div
                    onClick={() => handleOpenModal(selectedLead.lead_id)}
                    className="mb-4 flex items-center justify-between"
                  >
                    <label className="block font-medium mb-2 text-black text-opacity-60">
                      Attach File
                    </label>
                    <label
                      htmlFor="file-upload"
                      className="flex items-center gap-2 justify-center px-4 py-2 bg-gray-300 text-white rounded-lg cursor-pointer hover:bg-gray-400 transition-colors duration-200"
                    >
                      <img
                        src={attachfile}
                        alt="attachfile-icon"
                        className="w-5 h-5"
                      />
                    </label>
                    {/* <input
                    id="file-upload"
                    type="file"
                    name="file"
                    // onChange={(e) => handleFileAttachment(e, selectedLead)}

                    className="hidden"
                  /> */}
                    <p className=" text-sm text-gray-500 truncate">
                      {fileName}
                    </p>
                  </div>

                  {/* <div className="my-4 flex items-center justify-center gap-4 ">
 
  <label className="block font-medium text-black text-opacity-60">
    Attach File
  </label>

    <label
      htmlFor="file-upload"
      className="flex items-center gap-2 justify-center px-4 py-2 bg-gray-300 text-white rounded-lg cursor-pointer hover:bg-gray-400 transition-colors duration-200"
    >

      <img src={attachfile} alt="attachfile-icon" className="w-5 h-5" />
    </label>
   
    <input
      id="file-upload"
      type="file"
      name="file"
      onChange={handleChange}
      className="hidden"
    />

    <p className=" text-sm text-gray-500 truncate">
      {fileName}
    </p>
</div>  */}

                  {/* {selectedLead.file ? (
                  <div className="mb-4">
                    <p className="text-gray-600">Uploaded File:</p>
                    <p className="text-blue-500 underline">
                      {selectedLead.file.split("\\").pop() ||
                        "No name available"}
                    </p>
                  </div>
                ) : (
                  <p>No file uploaded</p>
                )} */}

                  <div className="mb-4">
                    <TextField
                      label="Notes"
                      fullWidth
                      multiline
                      rows={1}
                      variant="standard"
                      value={selectedLead.lead_notes || ""}
                      onChange={(e) => handleInputChange(e, "notes")}
                    />
                  </div>

                  <div className="flex justify-end space-x-4">
                    <Button variant="contained" color="primary" type="submit">
                      Save
                    </Button>
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={() => setShowDrawer(false)}
                    >
                      Cancel
                    </Button>
                  </div>
                </form>
              </div>

              {/* Activity Timeline */}
              <div className="w-[60%] bg-white p-4 rounded-md shadow-md max-h-[80vh] overflow-y-scroll">
                <ThemeProvider theme={theme}>
                  <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <TabList onChange={handleChange} aria-label="">
                        <Tab label="Lead Timeline" value="1" />
                        {/* <Tab label="Activity Log" value="2" /> */}
                      </TabList>
                    </Box>
                    {/* <TabPanel sx={{ padding: 0 }} value="2">
                      <ActivityLog leadsWithHistory={leadsWithHistory} />
                    </TabPanel> */}
                    <TabPanel value="1" sx={{ padding: 0 }}>
                      <HistoryDisplay
                        rows2={rows}
                        leadsWithHistory={leadsWithHistory}
                        selectedLead={selectedLead}
                      />
                    </TabPanel>
                  </TabContext>
                </ThemeProvider>
              </div>
            </div>
          </>
        ) : (
          <p>No lead selected!!!</p>
        )}
      </div>
    </div>
  );
};

export default Drawer;
